import React, { Suspense } from 'react';
import { string, func } from 'prop-types';
import { Link } from 'react-router-dom';
import BookDemoButton from '../shared/BookDemoButton/BookDemoButton';
import OpacityButton from '../shared/OpacityButton/OpacityButtonNormalLink';
//import DropDown from '../shared/DropDown/DropDown';

import {
  Container,
  LinksContent,
  ButtonContent,
  //DropDownContent,
  HeaderContent,
  MarginBoxHeader,
  Anchor,
  Logo,
  BurgerBox
} from './HeaderLP.style';
import BurgerMenu from '../BurgerMenu/BurgerMenu';

import { useTranslation } from 'react-i18next';
import Loader from '../../components/shared/Loader/Loader'

const Header = ({ bgColor, buttonFunc }) => {
    const { t } = useTranslation();

    return (
  <Suspense fallback={<Loader />}>
    <Container bgColor={bgColor}>
      <MarginBoxHeader>
        <HeaderContent>
          <Link to="/digital-archive">
            <Logo />
          </Link>
          
          <ButtonContent>
            <BookDemoButton
                content="Quero marcar uma demonstração"
                maxWidth="500px"
                margin="0 10px 0 0" minheight="55px"
                doStuff={buttonFunc}
                swapColorOnOver={false}
            />
          </ButtonContent>
        </HeaderContent>
        {/*<BurgerBox>
          <BurgerMenu />
        </BurgerBox>*/}
      </MarginBoxHeader>
    </Container>
</Suspense>
  );
};

Header.propTypes = {
    bgColor: string,
    buttonFunc: func
};

Header.defaultProps = {
  bgColor: ''
};

export default Header;
